import React, { useMemo, useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Button,
  Row,
  Col
} from '@lockerpm/design';

import {
  UndoOutlined,
} from "@ant-design/icons";

import commonComponents from "../../../components/common";
import accountDrawersComponents from "./drawers/index";

import { KdfType } from "../../../core-js/src/enums/kdfType";
import { separatorNumber } from "../../../utils/common";

const UpdateEncryption = (props) => {
  const { UpdateEncryptionDrawer } = accountDrawersComponents;
  const { PageHeader } = commonComponents;

  const { t } = useTranslation();

  const isMobile = useSelector(state => state.system.isMobile);
  const userInfo = useSelector(state => state.auth.userInfo);

  const [formVisible, setFormVisible] = useState(false);


  const disabled = useMemo(() => {
    return userInfo?.kdf_version < 1;
  }, [userInfo])

  return (
    <div className="update-encryption layout-content">
      <PageHeader
        title={t('update_encryption.title')}
        subtitle={t('update_encryption.description')}
        actions={[]}
      />
      <Row className="mt-4" gutter={[16, 16]}>
        <Col lg={8} md={8} sm={8} xs={24}>
          <div className="flex flex-col gap-1">
            <p>
              <span className="font-semibold">{t('update_encryption.algorithm')}</span>: {userInfo?.kdf === KdfType.PBKDF2_SHA256 ? 'PBKDF2' : 'ARGON2ID'}
            </p>
            <p><span className="font-semibold">{t('update_encryption.iterations')}</span>: { separatorNumber(userInfo.kdf_iterations) }</p>
            {
              userInfo?.kdf === KdfType.ARGON2ID && <>
                <p><span className="font-semibold">{t('update_encryption.memory')}</span>: { separatorNumber((userInfo?.kdf_memory || 0) / 1024) }</p>
                <p><span className="font-semibold">{t('update_encryption.parallelism')}</span>: { separatorNumber(userInfo.kdf_parallelism || 0) }</p>
              </>
            }
          </div>
        </Col>
        <Col lg={8}  md={16} sm={16} xs={24}>
          <Button
            type='primary'
            ghost
            icon={<UndoOutlined />}
            disabled={disabled}
            onClick={() => setFormVisible(true)}
          >
            {isMobile ? '' : t('update_encryption.action')}
          </Button>
        </Col>
      </Row>
      <UpdateEncryptionDrawer
        visible={formVisible}
        onClose={() => setFormVisible(false)}
      />
    </div>
  );
}

export default UpdateEncryption;
